"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _numberFormatter = require("./numberFormatter");
Object.keys(_numberFormatter).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _numberFormatter[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _numberFormatter[key];
    }
  });
});
var _parseNumber = require("./parseNumber");
Object.keys(_parseNumber).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _parseNumber[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _parseNumber[key];
    }
  });
});